import { cn } from '@/lib/utils';
import { isSupportedProductType as isSupported } from '@/util/isSupportedProductType';
import { ForwardedRef, forwardRef } from 'react';
import { Info } from 'react-feather';
import Button from '../Button';

export const AddCartButton = forwardRef(
  (
    {
      isPreOrder,
      note,
      isOutOfStock,
      isAdding,
      label,
      product,
      item,
      classes,
    }: {
      isPreOrder: boolean;
      note: string;
      isOutOfStock: boolean;
      isAdding: boolean;
      label: string;
      product: any;
      item: any;
      classes?: string;
    },
    ref: ForwardedRef<HTMLElement>,
  ) => {
    const productType = product.__typename;

    const isSupportedProductType = isSupported(productType);

    const maybeIsPreorder = (
      <p
        className={cn(
          'flex h-10 w-full items-center justify-center lg_h-[50px]',
          'font-roboto-medium font-medium uppercase',
          'bg-[#f8f8f8]',
          ' text-orange',
        )}
      >
        {note}
      </p>
    );

    const maybeOutOfStockInfo = isOutOfStock ? (
      <p
        className={cn(
          'flex h-10 w-full items-center justify-center lg_h-[50px]',
          'font-roboto-medium font-medium ',
          'bg-[#f8f8f8]',
          ' text-b23c3c',
          'rounded-[102px]',
        )}
      >
        Sorry, Item is Out of Stock!
      </p>
    ) : null;

    const cartCallToActionPreOrderText = isAdding ? 'ADDING...' : <span>{label || 'PRE-ORDER'}</span>;

    const cartActionPreOrder = (
      <>
        {maybeIsPreorder}
        <Button
          priority='high'
          loading={isAdding}
          type='submit'
        >
          {cartCallToActionPreOrderText}
        </Button>
      </>
    );

    const cartCallToActionText = isAdding ? 'Adding...' : !isOutOfStock ? 'Add to Cart' : 'Notify Me';

    const cartActionContent = isSupportedProductType ? (
      <>
        {maybeOutOfStockInfo}
        <Button
          className={cn(
            'flex h-10 w-full items-center justify-center rounded-[102px] bg-black font-roboto-medium text-base font-medium leading-none text-white lg_h-[50px] lg_text-lg lg_hover_bg-4c4c4c',
            classes?.btnClass,
          )}
          priority='high'
          loading={isAdding}
          type='submit'
        >
          {cartCallToActionText}
        </Button>
      </>
    ) : (
      <div
        className={cn(
          'bg-subtle',
          'gap-x-2xs',
          'grid',
          'grid-flow-col',
          'italic',
          'items-center',
          'justify-start',
          'p-3',
          'text-subtle',
          'w-full',
        )}
      >
        <Info />
        <p>This product is currently unavailable for purchase.</p>
      </div>
    );

    if (!item && productType === 'ConfigurableProduct') {
      return (
        <p
          className={cn(
            'h-10 w-full lg_h-[50px]',
            'font-roboto-medium font-medium ',
            'bg-[#f8f8f8]',
            'text-center text-b23c3c',
            'mt-xs',
            'flex items-center justify-center rounded-[102px]',
          )}
        >
          Sorry, Item is Out of Stock!
        </p>
      );
    }

    return (
      <section
        className={cn('gap-y-5 lg_gap-y-[30px]', ' flex flex-col ')}
        ref={ref}
      >
        {isPreOrder ? cartActionPreOrder : cartActionContent}
      </section>
    );
  },
);
